import React, { Component } from 'react';
import axios from 'axios';
import { NavLink, Navigate, useNavigate  } from 'react-router-dom';
import {Button,Dialog,DialogTitle,DialogContent,DialogActions,Typography,Box,TablePagination,TextField,Card,CardContent,CardActions} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Serverurl from './Apiurl';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Fab from '@mui/material/Fab';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CallIcon from '@mui/icons-material/Call';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import editIconImg from './images/edit.png'; 
import deleteIconImg from './images/delete.png'; 



class Customerlist extends Component {
  constructor(props) {
    super(props);
    this.state = {customers: [],totalItems: 0,page: 0,rowsPerPage: 5, 
      itemsPerPageOptions: [5, 10, 25, 50],logredirect: false,
      pagename: '',searchName: '',
    };
  }

  componentWillMount() {
	  if(localStorage.getItem("GBuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Businesslogin'
          })
		  }
    this.fetchCustomers();
  }

  handleSearchChange = (e) => {
    this.setState({ searchName: e.target.value });
  };

  fetchCustomers = () => {
  const bu_id = localStorage.getItem("GBuserid");

  if (!bu_id) {
    this.setState({
      logredirect: true,
      pagename: "/Businesslogin"
    });
    return;
  }

  axios.get(
    Serverurl +
      "ajaxcustomer.php?action=getall" +
      "&StartIndex=" + this.state.page +
      "&PageSize=" + this.state.rowsPerPage +
      "&cu_name=" + this.state.searchName +
      "&cu_bu_id=" + bu_id  
  )
  .then((res) => {
    const totalItems = parseInt(res.data[0]?.total || 0);
    this.setState({ customers: res.data, totalItems });
  });
};
  onPageChange = (event, newPage) => {
    this.setState({ page: newPage }, this.fetchCustomers);
  };

  onRowsPerPageChange = (event) => {
    this.setState(
      { rowsPerPage: parseInt(event.target.value, 10), page: 0 },
      this.fetchCustomers
    );
  };

  searchCustomers = () => {
    this.setState({ page: 0 }, this.fetchCustomers);
  };


  handleDelete = (cu_id) => {
    confirmAlert({
      title: "Confirm Delete",
      message: "Are you sure you want to delete this Customer?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
			  const formData = new FormData();
    formData.append('action', 'delete');
    formData.append('cu_id', cu_id);
    formData.append('userid',localStorage.getItem("GBuserid"));

           axios.post(Serverurl + "ajaxcustomer.php", formData).then(() => {
      this.fetchCustomers();
    });
          }
        },
        { label: "No" },
      ],
    });
  };


  render() {
    if (this.state.logredirect) {
      return <Navigate to={this.state.pagename} />;
    }

    return (
      <div className="formdisplay">
       
 <Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 3,
    marginBottom: "10px",
  }}
>
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1.5,
    }}
  >
      <ChevronLeftIcon
  className="global-back-arrow"
  onClick={() => window.history.back()}
/>

    <Typography variant="h4">
      Customer
    </Typography>
  </Box>
</Box>

        
	<Box sx={{ mb: 3 }}>
  <TextField
    variant="outlined"
    value={this.state.searchName}
    onChange={this.handleSearchChange}
    onKeyDown={(e) => {
      if (e.key === 'Enter') {
        this.searchCustomers();
      }
    }}
    size="small"
    fullWidth
    placeholder="Search by Name / Phone / Email"
    sx={{
 
      borderRadius: '50px',
      '& .MuiOutlinedInput-root': {
        borderRadius: '50px',
		border: '0.5px solid #c0c0c0',
		padding: '3px 0px !important',
        paddingRight: '4px',
        '& fieldset': {
          borderColor: '#e2e8f0',
        },
        '&:hover fieldset': {
          borderColor: '#cbd5e1 !important',
        },
        '&.Mui-focused fieldset': {
          borderColor: '#11408f !important',
        },
      },
      '& .MuiOutlinedInput-input': {
        paddingLeft: '20px !important',
        fontSize: '14px',
      },
    }}
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <IconButton
            onClick={this.searchCustomers}
            sx={{
              backgroundColor: '#11408f',
              color: '#ffffff',
			  width: '56px',
			  
              padding: '13px',
              '&:hover': {
                backgroundColor: '#0d3476',
              },
            }}
          >
            <SearchIcon fontSize="small" />
          </IconButton>
        </InputAdornment>
      ),
    }}
  />
</Box>

        
        <ul style={{ listStyle: 'none', padding: 0}}>
          {this.state.customers.length > 0 ? (
            this.state.customers.map((item) => (
              <li key={item.cu_id} style={{ marginBottom: 20 }}>
                <Card elevation={3}>
				<div className="cardcontent">
                  <CardContent>
                    <Typography variant="h6">{item.cu_name}</Typography>

                    <Typography variant="body2" color="text.secondary">
                      {item.cu_companyname}
                    </Typography>

                    <Typography 
  variant="body2" 
  sx={{ 
    mt: 1, 
    display: 'flex', 
    alignItems: 'center', 
    gap: 1, 
    fontSize: '13px', 
    color: '#334155',
	
  }}
>
  <CallIcon sx={{ fontSize: '15px', color: '#1e293b' }} />| {item.cu_phoneno} 
                      
                    </Typography>

                   

                  </CardContent>
				  </div>
<div className="cardactions">
                  <CardActions sx={{ justifyContent: 'flex-end' }}>
                    <a
                      href={'/Addcustomer?cid=' + item.cu_id}
             
                    >
<img
        src={editIconImg}
        alt="Edit"
        style={{ width: '28px' }}
      />
                    </a>

                   <Button
      className="frmthirdbtn"
      onClick={() => this.handleDelete(item.cu_id)}

    >
      <img
        src={deleteIconImg}
        alt="Delete"
        style={{ width: '28px' }}
      />
    </Button>
                  </CardActions>
				  </div>
                </Card>
              </li>
            ))
          ) : (
            <Typography align="center">No customers found</Typography>
          )}
        </ul>

        
      {this.state.totalItems > 0 && (
  <TablePagination
    component="div"
    count={this.state.totalItems}
    page={this.state.page}
    onPageChange={this.onPageChange}
    rowsPerPage={this.state.rowsPerPage}
    onRowsPerPageChange={this.onRowsPerPageChange}
    rowsPerPageOptions={this.state.itemsPerPageOptions}
  />
)}

       {/* Floating Add Button */}
<NavLink to="/AddCustomer" style={{ textDecoration: 'none' }}>
  <Fab
    aria-label="add"
    sx={{
      position: 'fixed',
      bottom: 30,
      right: 30,
      zIndex: 1000,
      backgroundColor: '#11408f',   
      color: '#ffffff', 
'&:hover': {
        backgroundColor: '#0d3476', 
      },	  
    }}
  >
    Add
  </Fab>
</NavLink>

	   
      </div>
    );
  }
}

export default Customerlist;
